export default "__VITE_ASSET__ceffd558__"